import { Deserializable } from '../_common/deserializable';

export class TxKeyword implements Deserializable{
    id: number;
    source: number;
    sourceView: string;
    shortCode: string;
    keyword: string;
    secondKeyword: string;
    productId: string;
    operator: string;
    operatorId: string;
    currency: string;
    country: string;
    timezone: string;
    mcc: string;
    mnc: string;
    category: number;
    categoryView: string;
    interval: number;
    intervalView: string;
    schedules: string;
    contentSchedules: string;
    price: number;
    priceId: string;
    minHour: number;
    maxHour: number;
    txPrefix: string;
    mtContentEnabled: boolean;
    renewalEnabled: boolean;
    broadcast: boolean;
    senderId: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
